import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

/**
 * Componente que impede usuários logados de acessarem rotas (ex: Login, Cadastro).
 * Recebe o componente a ser renderizado via prop 'element'.
 */
const GuestRoute = ({ element: Component }) => {
  const { user, loading } = useAuth();

  if (loading) return null;

  // Se há um usuário logado, redireciona para a página principal (home)
  if (user) {
    return <Navigate to="/" replace />;
  }

  // Se não há usuário logado, permite o acesso ao componente
  return Component;
};

export default GuestRoute;
